import React from 'react';
import './Components.css'

const LoaderMessage = ({ loaderMessage }) => {
    console.log('LoaderMessage rendered');
    return (
        <div className="loader-container">
            <div className="loader"></div>
            <div className="loader-message">{loaderMessage}</div>
        </div>
    );
};

export default LoaderMessage;
